export default {
    day: '2023-10-17',
    content: {
        meta: [
            {
                type: 'bugfix',
                text: '171'
            }
        ],
        horde: [
            {
                unlock: 'hordeEquipment',
                type: 'clarity',
                text: '162'
            },
            {
                unlock: 'hordePrestige',
                type: 'qol',
                text: '163'
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '165',
                balance: 'nerf',
                before: '+1%',
                after: '+0.8%'
            },
            {
                type: 'clarity',
                text: '167'
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '168',
                balance: 'buff',
                before: '4x',
                after: '1.5x'
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '169',
                balance: 'buff',
                before: '20%',
                after: '50%'
            },
            {
                unlock: 'hordePrestige',
                type: 'bugfix',
                text: '170'
            },
            {
                type: 'qol',
                text: '166'
            }
        ],
        general: [
            {
                type: 'bugfix',
                text: '159'
            },
            {
                type: 'balance',
                text: '164'
            }
        ],
        event: [
            {
                type: 'info',
                text: '160'
            }
        ],
        cryolab: [
            {
                type: 'new',
                text: '158'
            },
            {
                type: 'balance',
                text: '161'
            }
        ],
    }
}
